import React from 'react';
const MinusIcon = () => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M19.0001 13H5.00012V11H19.0001V13Z", fill: "#363948" })));
};
export default MinusIcon;
